import React, { PropsWithChildren, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { observer } from 'mobx-react';
import { ApiRole } from '@ibe/api';
import { useAuth } from '@ibe/components';
import { PageUrl } from '../pages';
import { useMount } from 'react-use';

interface Props {
  redirectTo: string;
  requiredRoles: ApiRole[];
}

const ProtectedRoute = observer(
  ({ children, requiredRoles, redirectTo }: PropsWithChildren<Props>) => {
    const authHook = useAuth();
    const location = useLocation();
    const [routeState, setRouteState] = useState<{
      stayOnRoute: boolean;
      checkingAuth: boolean;
    }>({ stayOnRoute: true, checkingAuth: true });

    useMount(() => {
      const { token } = authHook.authState;
      if (token) {
        authHook.authService.fromJwt(token);
        if (
          requiredRoles.length > 0 &&
          authHook.authService.state.role !== null &&
          requiredRoles.includes(authHook.authService.state.role)
        ) {
          setRouteState({ stayOnRoute: true, checkingAuth: false });
        } else {
          setRouteState({ stayOnRoute: false, checkingAuth: false });
        }
      } else {
        setRouteState({ stayOnRoute: false, checkingAuth: false });
      }
    });

    return !routeState.checkingAuth ? (
      routeState.stayOnRoute ? (
        children
      ) : (
        <Navigate to={PageUrl.LOGIN} state={{ from: location }} />
      )
    ) : (
      <></>
    );
  }
);

export default ProtectedRoute;
